import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
  Typography,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QRCode from 'react-qr-code';
import GpayImage from '../../Image/UPIOptions/Gpay.png';
import PhonePeImage from '../../Image/UPIOptions/PhonePe.png';
import PaytmImage from '../../Image/UPIOptions/Paytm.png';
import AmazonPay from '../../Image/UPIOptions/AmazonPay.png';

const UPIQRDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const upiString = 'upi://pay?pa=vaysolar@icici&pn=VaySolar&cu=INR';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          border: '20px solid white',
          borderRadius: '10px',
        },
      }}
    >
      <DialogTitle>
        Scan to pay
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center' }}>
        <Box sx={{ background: 'white', p: 2, display: 'inline-block' }}>
          <QRCode value={upiString} size={180} />
        </Box>

        <Typography
          variant='h6'
          fontWeight={600}
          color={'text.secondary'}
          sx={{ mt: 2, fontWeight: 500 }}
        >
          vaysolar@icici
        </Typography>
        <Typography mt={1}>Scan and pay with any BHIM UPI app</Typography>

        <Box
          sx={{
            mt: 2,
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <img src={GpayImage} alt='GPay' height={32} />
          <img src={PhonePeImage} alt='PhonePe' height={32} />
          <img src={PaytmImage} alt='Paytm' height={30} />
          <img src={AmazonPay} alt='Amazon Pay' height={32} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default UPIQRDialog;
